import { render, staticRenderFns } from "./PageMessagesForAdmin.vue?vue&type=template&id=0cadd486&"
import script from "./PageMessagesForAdmin.vue?vue&type=script&lang=ts&"
export * from "./PageMessagesForAdmin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports